import { Link, Typography } from "@mui/material";
import { makeStyles } from "@mui/styles";
import { getSupportLink } from "../../../Helpers";

const assistanceMessage =
  "Need further assistance? If your question isn’t listed here or the provided solutions don’t resolve your issue, please contact us here. We’re here to help!";

const useStyles = makeStyles((theme) => ({
  root: {
    [theme.breakpoints.down("md")]: {
      padding: "0px",
    },
  },
  bold: {
    fontWeight: 700,
  },
}));
export const FAQFooter = ({ dark = false }: { dark?: boolean }) => {
  const classes = useStyles();
  return (
    <Typography
      variant="body1"
      component="p"
      color={dark ? "#FFF" : "#474747"}
      className={classes.root}>
      <span className={classes.bold}>Need further assistance?</span>
      <span style={{ fontWeight: 400 }}>
        {" "}
        If your question isn’t listed here or the provided solutions don’t resolve your
        issue, please don't hesitate to{" "}
        <Link
          href={getSupportLink(true)}
          target="_blank"
          rel="noopener noreferrer"
          aria-label={`${assistanceMessage} (opens in new tab)`}
          sx={{
            color: dark ? "#FFF" : "#005685",
            textDecoration: "underline",
            "&:hover": {
              color: dark ? "#FFF" : "#005685",
              textDecoration: "underline",
            },
          }}>
          contact us here
        </Link>
        . We’re here to help!
      </span>
    </Typography>
  );
};
